import React, { useState } from "react";
import { useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { faDownload, faShareAlt } from '@fortawesome/free-solid-svg-icons';
import "./ProductCard.css";
import ProductDetails from "./ProductDetails";

const ProductCard = ({ item }) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const { productId } = useParams();

  if (!item) return null;

  const storageKey = `product-image-order-${item?.id || item?.uniqueId || item?.uniqueRecordId}`;

  const getOrderedImages = () => {
    const images = item.imageItems?.length
      ? [...item.imageItems]
      : (item.imageUrls || []).map((url, index) => ({
          id: item.imageIds?.[index],
          url,
        }));

    const savedUrls = localStorage.getItem(`${storageKey}-urls`);
    const savedOrder = localStorage.getItem(storageKey);

    if (savedUrls) {
      try {
        const orderedUrls = JSON.parse(savedUrls);
        const orderedImages = orderedUrls
          .map((savedUrl) => images.find((image) => String(image.url) === String(savedUrl)))
          .filter(Boolean);
        const remainingImages = images.filter(
          (image) => !orderedUrls.some((savedUrl) => String(savedUrl) === String(image.url))
        );
        return [...orderedImages, ...remainingImages];
      } catch (error) {
        // Fall through to id-based ordering
      }
    }

    if (!savedOrder) {
      return images;
    }

    try {
      const orderedIds = JSON.parse(savedOrder);
      const orderedImages = orderedIds
        .map((savedId) => images.find((image) => String(image.id) === String(savedId)))
        .filter(Boolean);
      const remainingImages = images.filter(
        (image) => !orderedIds.some((savedId) => String(savedId) === String(image.id))
      );
      return [...orderedImages, ...remainingImages];
    } catch (error) {
      return images;
    }
  };

  const orderedImages = getOrderedImages();
  const primaryImage = orderedImages?.[0]?.url || item.imageUrls?.[0] || 'path/to/your/default-image.jpg';


  const handleDeleteSuccess = () => {
    setIsDeleted(true);
    setIsDialogOpen(false);
  };

  // Function to handle image download
  const handleDownload = async () => {
    const imageSrc = primaryImage;

    fetch(imageSrc)
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.blob();
      })
      .then(imageBlob => {
        const fileURL = URL.createObjectURL(imageBlob);
        const link = document.createElement('a');
        link.href = fileURL;
        link.download = item.stylename ? item.stylename.replace(/\s+/g, '_') : 'download';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(fileURL);
      })
      .catch(error => {
        console.error('Failed to download the image:', error);
        alert('Failed to download the image. See console for details.');
      });
  };

  // Function to handle sharing
  const handleShare = async () => {
    if (navigator.share) {
      try {
        const productUrl = `${window.location.origin}/products/${item.uniqueId}?details=open`;
        await navigator.share({
          title: item.stylename || 'Check out this product!',
          url: productUrl,
          text: 'Take a look at this amazing product!'
        });
      } catch (error) {
        console.error("Error sharing", error);
        alert("Failed to share. See console for details.");
      }
    } else {
      console.log("Web Share API is not supported in this browser.");
      // Optionally, copy to clipboard as a fallback
      navigator.clipboard.writeText(`${window.location.origin}/products/${item.uniqueId}?details=open`)
        .then(() => alert('Link copied to clipboard!'))
        .catch(err => console.error('Failed to copy link: ', err));
    }
  };

  // Function to open the dialog
  const handleOpenDialog = () => {
    if (!isDialogOpen) {
      setIsDialogOpen(true);
    }
  };

  // Function to close the dialog
  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  if (isDeleted) return null;

  return (
    <div className="product-card" onClick={handleOpenDialog}>
      <h2>{item.stylecode || 'No Style Name'}</h2>
      {!imageLoaded && <div className="image-placeholder">Loading...</div>}
      <img
        src={primaryImage}
        alt={item.stylename || 'Product image'}
        style={{ display: imageLoaded ? 'block' : 'none' }}
        onLoad={() => setImageLoaded(true)}
      />
      {/* <p>Category: {item.category || 'No Category'}</p>
      <p>Type: {item.producttype || 'No Product Type'}</p> */}




      {/* <div className="actions" onClick={(e) => e.stopPropagation()}>
        <button onClick={(e) => { e.stopPropagation(); handleDownload(); }}>
          <FontAwesomeIcon icon={faDownload} />
        </button>
        <button onClick={(e) => { e.stopPropagation(); handleShare(); }}>
          <FontAwesomeIcon icon={faShareAlt} />
        </button>
      </div> */}
      {/* Dialog for product details */}
      <Dialog open={isDialogOpen} onClose={handleCloseDialog} PaperProps={{
        sx: {
          width: "100%",
          maxWidth: "79%",
          maxHeight: "100%",
          overflowX: "scroll",
          overflowY: "scroll",
          scrollBehavior: "auto",
        },
      }}>
        <DialogTitle id="dialog-title" sx={{ textAlign: 'center' }}>{item.stylename || 'No Style Name'}</DialogTitle>
        <DialogContent>
          <ProductDetails productDetails={item} onDeleteSuccess={handleDeleteSuccess} />
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default ProductCard;
